import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
// components
import MaskedInput from 'react-maskedinput';
// utils
import classnames from 'classnames/bind';
import moment from 'moment/moment';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import {
  getInputMask,
  getInputPlaceholder,
  formatDateForBackend,
  formatDateForUser
} from 'utils/regionalDateHelper';
// styles
import styles from './DateInput.module.scss';

const cn = classnames.bind(styles);

const DateInput = ({
  onChange, value, className, onClear, onMobileChange, max,
  icon, clearable, countryCode
}, { isMobile }) => {

  const mask = getInputMask();
  const placeholder = getInputPlaceholder(countryCode);

  // Format value for display (convert backend format to user format for mobile)
  const displayValue = isMobile && value ? formatDateForUser(value, countryCode) : value;

  const handleChange = (e) => {
    const userInput = e.target.value;
    if (userInput && onMobileChange) {
      // Convert user regional input to backend format
      const backendDate = formatDateForBackend(userInput, countryCode);
      onMobileChange(backendDate);
    } else if (onMobileChange) {
      onMobileChange('');
    }
  };

  return (
    <div className={cn('DateInput', className)}>
      {isMobile ? (
        <div className={cn('birthdate-field', { selected: value })}>
          <input
            className={cn('mobile-input')}
            placeholder={placeholder}
            value={displayValue}
            max={max}
            readOnly
            type="text"
          />
          {value && clearable && (
            <span onTouchEnd={(e) => { e.preventDefault(); onClear(); }} className={cn('clear-date')}>
              <i className="fa fa-times" />
            </span>
          )}
          <input
            className={cn('mobileDateInput')}
            max={moment().format('YYYY-MM-DD')}
            onChange={handleChange}
            type="date"
          />
        </div>
      ) : (
        <div className={cn('birthdate-field')}>
          <div className={cn('masked-input', { 'labeled': icon })}>
            <MaskedInput
              mask={mask}
              name="birthdate"
              placeholder={placeholder}
              onChange={onChange}
              value={value}
            />
            {value && clearable && (
              <span onClick={onClear} className={cn('clear-date')}>
                <i className="fa fa-times" />
              </span>
            )}
          </div>

          {icon && (<div className={cn('icon-label')}><i className="fa fa-calendar" /></div>)}
        </div>
      )}
    </div>
  );
};

DateInput.contextTypes = {
  isMobile: T.bool,
};

DateInput.propTypes = {
  value: T.string,
  max: T.string,
  onChange: T.func,
  onClear: T.func,
  onMobileChange: T.func,
  icon: T.bool,
  clearable: T.bool,
  className: T.string,
  countryCode: T.string,
};

DateInput.defaultProps = {
  countryCode: 'US',
};

export default connect(
  (state) => ({
    countryCode: getCurrentCountryCode(state)
  })
)(DateInput);
